import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const downloadJSON = (timeline) => {
  const data = {
    title: timeline.title, description: timeline.description, category: timeline.category,
    layout: timeline.layout, theme: timeline.theme,
    events: (timeline.events || []).map((e) => ({
      date: e.date, year: e.year, title: e.title, subtitle: e.subtitle,
      description: e.description, image: e.image, quote: e.quote, location: e.location,
      url: e.url, source: e.source, category: e.category, tags: e.tags,
    })),
    exported_by: "Timeline by Mahakali Studios", exported_at: new Date().toISOString(),
  };
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
  triggerDownload(URL.createObjectURL(blob), `${slug(timeline.title)}.json`);
};

const capture = (node) => html2canvas(node, { scale: 2, backgroundColor: "#ffffff", useCORS: true, logging: false });

export const exportPNG = async (node, title) => {
  const canvas = await capture(node);
  triggerDownload(canvas.toDataURL("image/png"), `${slug(title)}.png`);
};

export const exportPDF = async (node, title) => {
  const canvas = await capture(node);
  const img = canvas.toDataURL("image/png");
  const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const imgH = (canvas.height * pageW) / canvas.width;
  let left = imgH;
  let pos = 0;
  pdf.addImage(img, "PNG", 0, pos, pageW, imgH);
  left -= pageH;
  while (left > 0) {
    pos -= pageH;
    pdf.addPage();
    pdf.addImage(img, "PNG", 0, pos, pageW, imgH);
    left -= pageH;
  }
  pdf.save(`${slug(title)}.pdf`);
};

const slug = (t) => (t || "timeline").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 50);

const triggerDownload = (href, filename) => {
  const a = document.createElement("a");
  a.href = href; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
};
